"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
exports.useRefListener = function (ref, eventName, callback) {
    var current = ref.current;
    var _current = react_1.useMemo(function () { return current; }, [current]);
    var _eventName = react_1.useMemo(function () { return eventName; }, [eventName]);
    var _callback = react_1.useMemo(function () { return callback; }, [callback]);
    var prevCallback = react_1.useRef(callback);
    react_1.useEffect(function () {
        if (_callback !== prevCallback.current) {
            _current && _current.removeEventListener(_eventName, prevCallback.current, false);
            prevCallback.current = _callback;
        }
        _current && _current.addEventListener(_eventName, _callback, false);
    }, [_current, _eventName, _callback]);
    react_1.useEffect(function () {
        return function () { var _a; return (_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.removeEventListener(_eventName, prevCallback.current, false); };
    }, [_eventName]);
};
